<template>
    <b-card :title="title" class="chart-container">
        <slot></slot>
    </b-card>
</template>
<script>
export default {
    props: {
        title: {}
    }
}
</script>
<style scoped>
    .chart-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>